import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import App from './App';
import './index.css';







// Basic theme for ThemeProvider (Styled Components/Emotion)
const theme = {
  colors: {
    primary: '#007bff',
    secondary: '#6c757d',
    background: '#ffffff',
    text: '#212529',
  },
  fonts: ['sans-serif', 'Roboto'],
  fontSizes: {
    small: '1em',
    medium: '2em',
    large: '3em'
  }
};

const rootElement = document.getElementById('root')!;
const appContent = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

ReactDOM.createRoot(rootElement).render(
  appContent
);